import { createApp } from 'vue';

import applicationFormApp from './vue/applicationForm';
import constants from './shared/constants';
import vacancyFormApp from './vue/vacancyForm';
import vacancyListApp from './vue/vacancyList';
import volunteerGroupListApp from './vue/volunteerGroupList';
import volunteerGroupsMapApp from './vue/volunteerGroupsMap';

document.addEventListener('DOMContentLoaded', () => {
    const applicationFormContainer = document.querySelector<HTMLElement>(constants.targets.applicationForm.root);
    const vacancyFormContainer = document.querySelector<HTMLElement>(constants.targets.vacancyForm.root);
    const vacancyListContainer = document.querySelector<HTMLElement>(constants.targets.vacancyList.root);
    const volunteerGroupListContainer = document.querySelector<HTMLElement>(constants.targets.volunteerGroupList.root);
    const volunteerGroupsMapContainers = document.querySelectorAll<HTMLElement>(constants.targets.volunteerGroupsMap.root);

    if (applicationFormContainer) {
        createApp(applicationFormApp).mount(applicationFormContainer);
    }

    if (vacancyFormContainer) {
        createApp(vacancyFormApp).mount(vacancyFormContainer);
    }

    if (vacancyListContainer) {
        createApp(vacancyListApp).mount(vacancyListContainer);
    }

    if (volunteerGroupListContainer) {
        createApp(volunteerGroupListApp).mount(volunteerGroupListContainer);
    }

    volunteerGroupsMapContainers.forEach((container) => {
        createApp(volunteerGroupsMapApp).mount(container);
    });
});
